/**
 * A utility class holding the storage keys used by the application.
 */
export class StorageKey {
  static readonly GLOBAL_NAMESPACE: string = 'ontotext.gdb';
}
